import { Link } from "react-router-dom";

export const NotFound = () => {
	return (
		<div className="container not-found">
			<div className="not-found__content">
				<h2 className="not-found__title">Oops! Page not found</h2>
				<p className="not-found__message">
					The page you are looking for doesn't exist.
				</p>
				<Link
					className="not-found__link"
					to="/"
				>
					Return to the About page
				</Link>
			</div>
		</div>
	);
};
